import { render } from "./DocumentGrid.vue?vue&type=template&id=59762b18&scoped=true"
import script from "./DocumentGrid.vue?vue&type=script&lang=js"
export * from "./DocumentGrid.vue?vue&type=script&lang=js"

import "./DocumentGrid.vue?vue&type=style&index=0&id=59762b18&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59762b18"]])

export default __exports__